import React, { useEffect, useState } from "react";
import { MdCalendarToday } from "react-icons/md";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import InputBox from "./InputBox";
import moment from "moment";

const DateRangeWithArrow = ({ handleChange }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [tempStartDate, setTempStartDate] = useState(new Date());
  const [tempEndDate, setTempEndDate] = useState(new Date());
  const [initial, setInitial] = useState(true);
  const [selectedRange, setSelectedRange] = useState(
    `${moment(startDate).format("MMM DD, YYYY")} - ${moment(endDate).format(
      "MMM DD, YYYY"
    )}`
  );

  const formatDate = (date) => {
    const options = { day: "numeric", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-GB", options);
  };

  const handleArrowClick = () => setShowDropdown(!showDropdown);

  const adjustDateRange = (date) => {
    console.log(date)
    const newStartDate = new Date(date);
    const newEndDate = new Date();

    newStartDate.setDate(Math.floor((newStartDate.getDate() - 1) / 10) * 10 + 1);

    if (newStartDate.getDate() > 20) {
      const lastDay = new Date(
        newStartDate.getFullYear(),
        newStartDate.getMonth() + 1,
        0
      );
      newEndDate.setDate(lastDay.getDate());
    } else {
      newEndDate.setDate(newStartDate.getDate() + 9);
    }

    setTempStartDate(newStartDate);
    setTempEndDate(newEndDate);
    setInitial(false);
  };

  useEffect(() => {
    adjustDateRange(new Date());
  }, []);

  useEffect(() => {
    handleApplyClick();
  }, [tempStartDate, tempEndDate]);

  useEffect(() => {
    setSelectedRange(
      `${formatDate(tempStartDate)} - ${formatDate(tempEndDate)}`
    );
  }, [tempStartDate, tempEndDate]);

  const handleStartDateChange = (e) =>
    setTempStartDate(new Date(e.target.value));
  const handleEndDateChange = (e) => setTempEndDate(new Date(e.target.value));

  const handleApplyClick = () => {
    setStartDate(tempStartDate);
    setEndDate(tempEndDate);
    handleChange(
      moment(tempStartDate).format("YYYY-MM-DD"),
      moment(tempEndDate).format("YYYY-MM-DD")
    );
  };

  return (
    <div className="relative w-full max-w-2xl mx-auto">
      <div
        className="cursor-pointer w-full border border-gray-300 rounded-lg px-4 py-3 flex items-center justify-between bg-white shadow-md hover:shadow-lg transition"
        onClick={handleArrowClick}
      >
        <div className="flex items-center gap-2">
          <MdCalendarToday className="text-xl text-gray-600" />
          <span className="text-sm font-medium text-gray-700">
            {selectedRange}
          </span>
        </div>
        {showDropdown ? (
          <IoIosArrowUp className="text-lg" />
        ) : (
          <IoIosArrowDown className="text-lg" />
        )}
      </div>

      {showDropdown && (
        <div className="absolute z-50 mt-2 w-full bg-white rounded-lg shadow-xl border p-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <InputBox
              type="date"
              value={moment(tempStartDate).format("YYYY-MM-DD")}
              label="Start Date"
              onValueChange={handleStartDateChange}
            />
            <InputBox
              type="date"
              value={moment(tempEndDate).format("YYYY-MM-DD")}
              label="End Date"
              onValueChange={handleEndDateChange}
            />
          </div>

          <div className="flex flex-wrap gap-2 mt-4 text-sm">
            {[
              { label: "Last 10 Days", days: 10 },
              { label: "1 Month", months: 1 },
              { label: "3 Months", months: 3 },
              { label: "6 Months", months: 6 },
              { label: "All Time", all: true },
            ].map((option, idx) => (
              <button
                key={idx}
                onClick={() => {
                  let newStart;
                  const today = new Date();
                  if (option.all) {
                    let endDate = new Date();
                    newStart = new Date("2020-01-01");
                    setTempStartDate(newStart);
                    setTempEndDate(endDate);
                  } else {
                    if (option.days) {
                      newStart = new Date(today);
                      newStart.setDate(today.getDate() - option.days);
                    } else {
                      newStart = new Date(today);
                      newStart.setMonth(today.getMonth() - option.months);
                    }
                    adjustDateRange(newStart);
                  }
                }}
                className="px-3 py-1 bg-gray-100 hover:bg-blue-100 rounded-lg border border-gray-200"
              >
                {option.label}
              </button>
            ))}
          </div>

          <button
            onClick={() => {
              handleApplyClick();
              setShowDropdown(false);
            }}
            className="w-full mt-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
          >
            Apply
          </button>
        </div>
      )}
    </div>
  );
};

export default DateRangeWithArrow;
